module.exports = __webpack_public_path__ + "static/media/cuttingCheck.cdf8baa9.png";